export const ACCESS_TOKEN_TIME_RESERVE = 120; // sec
